// extracted by mini-css-extract-plugin
module.exports = {"jumbo-title":"jumbo-title--3U2Aj","jumboTitle":"jumbo-title--3U2Aj"};